import { Country, Validateable } from "@models";
import { Time } from "@models/time";

export interface ProfileModel {
	fullName: string;
	fullBirthday: string;
	countrySelected: Country;
	forename: string;
	surname: string;
	country_id: string;
	country_name: string;
	birthday: Time;
	street: string;
	street_line_2: string;
	city: string;
	zipcode: string;
	phonecode: string; // Frontend field
	phonenumber: string; // Frontend field
	mobile: string;
	phone_number_verified: boolean;
	visible: boolean;
	accepted_terms_data: boolean;
	accepted_terms_verification: boolean;
	taxId: string;
	business: string;
	email: string;
	citizenship_id: string;
	profile_id: string;
	iso?: string;
	agreement_bundles: string[];
	needs_tenancy_terms_approve: boolean;
	account_type?: string;
	place_of_birth?: string;
}

export class ProfileWithValidateable extends Validateable {
	public fullName: string;
	public fullBirthday: string;
	public countrySelected: Country;
	public forename: string;
	public surname: string;
	public country_id: string;
	public country_name: string;
	public birthday: Time;
	public street: string;
	public street_line_2: string;
	public city: string;
	public zipcode: string;
	public phonecode: string;
	public phonenumber: string;
	public mobile: string;
	public phone_number_verified: boolean;
	public visible: boolean;
	public accepted_terms_data: boolean;
	public accepted_terms_verification: boolean;
	public taxId: string;
	public business: string;
	public email: string;
	public citizenship_id: string;
	public profile_id: string;
	public iso: string;
	public agreement_bundles: string[];
	public needs_tenancy_terms_approve: boolean;
	public place_of_birth: string;

	constructor(profile: ProfileModel) {
		super();
		this.fullName = profile.fullName;
		this.fullBirthday = profile.fullBirthday;
		this.countrySelected = profile.countrySelected;
		this.forename = profile.forename;
		this.surname = profile.surname;
		this.country_id = profile.country_id;
		this.country_name = profile.country_name;
		this.birthday = profile.birthday;
		this.street = profile.street;
		this.street_line_2 = profile.street_line_2;
		this.city = profile.city;
		this.zipcode = profile.zipcode;
		this.phonecode = profile.phonecode;
		this.phonenumber = profile.phonenumber;
		this.mobile = profile.mobile;
		this.phone_number_verified = profile.phone_number_verified;
		this.visible = profile.visible;
		this.accepted_terms_data = profile.accepted_terms_data;
		this.accepted_terms_verification = profile.accepted_terms_verification;
		this.taxId = profile.taxId;
		this.business = profile.business;
		this.email = profile.email;
		this.citizenship_id = profile.citizenship_id;
		this.profile_id = profile.profile_id;
		this.iso = profile.iso;
		this.agreement_bundles = profile.agreement_bundles;
		this.needs_tenancy_terms_approve = profile.needs_tenancy_terms_approve;
		this.place_of_birth = profile.place_of_birth;
	}
}
